// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2W89w","footer":"ChangeClinic_footer__17hB0"};